import apiService from '../Api'
import { LiveData } from './types'

interface ILiveDataOptions {
  /** Also return artworks that were not made available for auction. Defaults to true. */
  includeNonAuction?: boolean
  /** Attach the last bids of each artwork (`recent_bids`). Defaults to false. */
  includeArtBids?: boolean
}

export class EventAdminService {
  async getLiveData(eventId: number, options: ILiveDataOptions = {}): Promise<LiveData> {
    const { includeNonAuction = true, includeArtBids = false } = options

    const params: Record<string, number> = {}
    if (includeNonAuction) params.include_non_auction = 1
    if (includeArtBids) params.include_art_bids = 1

    return apiService.get(`/events/${eventId}/machines/live-data`, { params }).then((response) => response.data)
  }

  async getWsSubscriptionCode(eventId: number): Promise<{ code: string; expires_in: number }> {
    return apiService.get(`/events/${eventId}/machines/ws-subscription-code`).then((response) => response.data)
  }
}
